import { Image } from '../types/product';

export const resolveThumbUrl = (image: Image) => {
  if (image.thumbUrl) return image.thumbUrl;
  return image.url.startsWith('https://graph')
    ? `${image.url}/thumb`
    : image.url || '/no-image.png';
};
